import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgKebabMenu',
})
export default class CmgKebabMenu extends Vue {
  @Prop({ required: false, type: String, default: '60px' })
  kebabMenuWidth?: string;

  get kebabMenuImageUrl(): string {
    return this.$appStore.state.cms.images.icons.kebabMenu.default;
  }
}
